import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassRoom } from '../classroom.js';
import { Teacher } from '../teacher.js';

export const getMyClassesQuery = registerQuery({
  operationName: 'getMyClassesQuery',
  type: () => [ClassRoom],
  params: [],

  resolve: () => async (_gqlFields: BaseQLSelectionSet<ClassRoom>): Promise<ClassRoom[]> => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) return [];

    const teacherCollection = await getCollection(Teacher);
    const teacher = await teacherCollection.findOne({ userID: currentUser._id });
    if (!teacher) return [];

    const classroomCollection = await getCollection(ClassRoom);
    const classrooms = await classroomCollection.find({ teacherID: teacher._id }).sort({ createdAt: -1 }).toArray();

    return classrooms as ClassRoom[];
  },
});
